export interface PlatformEnv {
  readonly platform?: string;
}

export function createPlatformEnv(rawHref?: string): PlatformEnv {
  const href = rawHref ?? (typeof window !== "undefined" ? window.location.href : "https://local.invalid");
  const base = typeof window !== "undefined" ? window.location.origin : "https://local.invalid";
  const url = new URL(href, base);

  return {
    platform: url.searchParams.get("platform") ?? undefined,
  };
}
